module.exports = __webpack_public_path__ + "img/logo-blue.e69c340d.png";